import { gridSortModelSelector, useGridApiContext, useGridSelector } from '@mui/x-data-grid-pro';

export const useFieldSortModel = (fieldName?: string) => {
  const apiRef = useGridApiContext();

  const sortModel = useGridSelector(apiRef, gridSortModelSelector);

  if (!fieldName) {
    return null;
  }

  return sortModel.find(({ field }) => field === fieldName);
};
